import Hero from '../sections/home/Hero'
// import TrustBar from '../sections/home/TrustBar'
import Reviews from '../sections/home/Review'
import LogoMarquee from '../sections/home/LogoMarquee'
import Services from '../sections/home/Services'
import PopularTrips from '../sections/home/PopularTrips'
import SkiTransfers from '../sections/home/SkiTransfers'
import VanTours from '../sections/home/VanTours'
import Fleet from '../sections/home/Fleet'
import WhyChoose from '../sections/home/WhyChoose'
import HowItWorks from '../sections/home/HowItWorks'
import TravelConfidence from '../sections/home/TravelConfidence'
import Testimonials from '../sections/home/Testimonials'
import FAQ from '../sections/home/FAQ'
import Footer from '../components/Footer'


export default function Home() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-page-gradient">
      <Hero />
      <Reviews />
      {/* <TrustBar /> */}
      <Services />
      <PopularTrips />
      <SkiTransfers />
      <VanTours />
      <WhyChoose />
      <Fleet />
      <HowItWorks />
      <TravelConfidence />
      <Testimonials />
      <LogoMarquee />
      <FAQ />
      <Footer />
    </div>
  )
}
